import React from "react";
import { PropTypes } from "prop-types";
import css from "../commonMagneticStyle.less";
import { useI18n } from "../../i18n/useI18n";

/**
 * Chart Legend renders list of items along with color
 * Usage:
 *
 */
const createQualityData = (tCommon) => [
  {
    label: tCommon("appDashboardQOEGoodLabel"),
    labelValue: tCommon("appDashboardQOEGoodValue"),
    color: "var(--hbr-color-success, #45991F)",
  },
  {
    label: tCommon("appDashboardQOEFairLabel"),
    labelValue: tCommon("appDashboardQOEFairValue"),
    color: "var(--hbr-color-warning-border, #cc8604)",
  },
  {
    label: tCommon("appDashboardQOEPoorLabel"),
    labelValue: tCommon("appDashboardQOEPoorValue"),
    color: "var(--hbr-color-danger, #cc2d37)",
  },
  {
    label: tCommon("appDashboardQOEUnknownLabel"),
    labelValue: tCommon("appDashboardQOEUnknownValue"),
    color: "var(--hbr-color-neutral-border, #889099)",
  },
];

const ChartLegend = ({
  style = {},
  data = [],
  includeQuality = false,
  ...props
}) => {
  const { tCommon } = useI18n("common");
  const qualityData = createQualityData(tCommon);
  const { applicationQoe, isBarTrend } = props;
  // merging
  const legendItems = includeQuality ? [...qualityData, ...data] : data;

  const items = legendItems.map((legend, idx) => (
    <div className="legend-color-container" data-cy={legend.label} key={idx}>
      {legend.type && legend.type === "dashed" ? (
        <span className="dashed"></span>
      ) : (isBarTrend || legend.type === "bar") &&
        legend.label &&
        legend.label.length > 0 ? (
        <span
          className="bar-legend-common"
          style={{ backgroundColor: `${legend.color}` }}
        ></span>
      ) : legend.label && legend.label.length > 0 ? (
        <span
          className="square"
          style={{ backgroundColor: `${legend.color}` }}
        ></span>
      ) : (
        ""
      )}

      <span className="hbr-type-body3">{legend.label}</span>
      {applicationQoe ? (
        <span className="hbr-type-body4">{legend.labelValue}</span>
      ) : (
        ""
      )}
    </div>
  ));

  return (
    <div
      className={
        applicationQoe && !isBarTrend && !props.reporting
          ? css["chart-legend-application-qoe"]
          : css["chart-legend"]
      }
      style={style}
      data-cy="chartLegend"
    >
      {items}
    </div>
  );
};

ChartLegend.propTypes = {
  style: PropTypes.object,
  data: PropTypes.array.isRequired,
  includeQuality: PropTypes.bool,
  applicationQoe: PropTypes.bool,
  isBarTrend: PropTypes.bool,
  reporting: PropTypes.bool,
  legendData: PropTypes.object,
};

export default ChartLegend;
